<template>
  <div id="app">
    <!--<keep-alive>-->
      <router-view/>
      
    <!--</keep-alive>-->
    
    <!-- <keep-alive>
      <router-view />
    </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
  },
}
</script>

<style>
#app {
  font-family: 'MicrosoftYaHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@media (min-width:500px){
  #app {
    overflow-y: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue